import { Grid, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const AccessDenied = () => {
  const navigate = useNavigate()
  return (
    <Grid container textAlign="center">
      <Grid item xs={12}>
        <img
          src="/images/forbidden.svg"
          alt="forbidden"
          style={{ height: '50vh' }}
        />
        <Typography variant="h6" className="p1">
          Sorry, it's not allowed to go beyond this point!
        </Typography>
        <Typography
          variant="h6"
          className="p2"
          onClick={() => navigate('/')}
          color="primary"
          sx={{ cursor: 'pointer' }}
        >
          Please, go back this way.
        </Typography>
      </Grid>
    </Grid>
  )
}

export default AccessDenied
